import type { ManagementHistoryEntry } from '@/frontend/features/Fde/projectManagementHistoryTypes'

export default function ManagementHistoryChanges({ entry, copy }: { entry: ManagementHistoryEntry; copy: Record<string, string> }) {
  return <details className="mt-2">
    <summary className="cursor-pointer text-xs text-muted-foreground hover:text-foreground">{copy.details}</summary>
    <dl className="mt-3 space-y-4 border-l border-border pl-3">
      {entry.changes.map((change) => <div key={change.label}>
        <dt className="mb-1 text-xs font-medium">{change.label}</dt>
        <dd className="grid gap-2 text-xs leading-5 sm:grid-cols-2">
          <div className="min-w-0"><p className="text-[10px] text-muted-foreground">{copy.before}</p><p className="whitespace-pre-wrap break-words text-muted-foreground">{change.before}</p></div>
          <div className="min-w-0"><p className="text-[10px] text-muted-foreground">{copy.after}</p><p className="whitespace-pre-wrap break-words">{change.after}</p></div>
        </dd>
      </div>)}
    </dl>
  </details>
}
